export default "__VITE_ASSET__e6e5ddf2__"